import i18n from 'modules/core/lib/i18n'

import PerDiemRatesBlock from '../../../Blocks/PerDiemRates'
import { CustomizationProps } from '../../../withCustomizationFields'
import { PermissionsProps } from '../../../withFieldPermissions'
import FormBlock from '../../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {}

const PerDiemRates = (props: Props) => {
  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.per_diem_rates_subtitle')}
    >
      <PerDiemRatesBlock {...props} loading={false} />
    </FormBlock>
  )
}

export default PerDiemRates
